import styled from "styled-components";
import { Type } from "theme/types";

export const DivTextHelp = styled.div`
    color: ${(props: Type) => props.theme.help.textHelp}
`

export const DivBgHelp = styled.div`
    background-color: ${(props: Type) => props.theme?.help?.backgroundHelp};
    ${({ theme }: Type) => theme?.help?.div}
`

export const AreaTextHelp = styled.textarea`
    color: ${(props: Type) => props.theme?.help?.textHelpArea}
`